export const meetingRouteNames = {
   PREVIEW: 'preview',
   ACTIVE: 'active',
   NEW: 'new',
   AGENDA: 'agenda',
   SUMMARY: 'summary',
};
